import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Observable, tap } from 'rxjs';
import { PublicService } from '../public/public.service';
import { Property, User } from '../shared/all.types';
import { NrjType } from '../shared/enums/property.enums';

export interface ConsentInfo {
  property: Property;
  user: User;
  nrjType: NrjType;
  token: string;
}

export interface PublicStateModel {
  property: Property | null;
  user: User | null;
  nrjType: NrjType | null;
  token: string;
}

export class GetConsentInfo {
  static readonly type = 'PUBLIC/GET_CONSENT_INFO';

  constructor(public token: string) {}
}

@State<PublicStateModel>({
  name: 'public',
  defaults: {
    property: null,
    user: null,
    nrjType: null,
    token: '',
  },
})
@Injectable()
export class PublicState {
  @Selector()
  public static consentInfo(state: PublicStateModel): ConsentInfo | null {
    const { property, user, nrjType, token } = state;

    return !!property && !!user && !!nrjType && !!token ? { property, user, nrjType, token } : null;
  }

  constructor(private readonly publicService: PublicService) {}

  @Action(GetConsentInfo)
  public getConsentInfo(ctx: StateContext<PublicStateModel>, action: GetConsentInfo): Observable<ConsentInfo> {
    return this.publicService.getConsentInfo(action.token).pipe(
      tap((result: ConsentInfo) => {
        ctx.patchState({ ...result, token: action.token });
      }),
    );
  }
}
